import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../reducers/rootReducer';
import { userDetailsSelectors } from '../../reducers/userDetailsSlice';
import Preloader from '../Preloader/Preloader';
import GeneralError from '../GeneralError/GeneralError';
import { EntityType } from '@/rtk/entityInfoApi';
import { NO_ROBOTS_FOUND_MESSAGE } from '@/common/constants';

function PreferredSystemsGuard({
  entityType,
}: {
  entityType: EntityType;
}): JSX.Element {
  const preferredSystems = useAppSelector(
    userDetailsSelectors.selectPreferredSystems,
  );

  const hasAccess = preferredSystems?.some(
    (s) => s.id === entityType || s.description === entityType,
  );

  if (preferredSystems && preferredSystems.length === 0) {
    return <Preloader activeByDefault />;
  }

  if (hasAccess === false) {
    return (
      <GeneralError
        message={NO_ROBOTS_FOUND_MESSAGE}
        icon="lely-icon-no-robots"
        title="No robots found"
      />
    );
  }

  return <Outlet />;
}

export default PreferredSystemsGuard;
